import React from "react";
/**
 * @typedef ProductGroup
 * @property {number} GroupID
 * @property {string} GroupName
 */
export { };
/**
 * 
 * @param {Object} props
 * @param {ProductGroup} props.group
 * @param {bool} props.selected
 * @param {(number)=>void} props.onClick
 * @returns 
 */
const ProductGroupItem = ({
    group,
    selected,
    onClick
}) => {



    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick(group.GroupID);
        }
    };

    return (
        <button
            type="button"
            className={
                `product-group-item ${selected
                    ? "product-group-item-selected"
                    : ""
                }`
            }
            onClick={handleClick}
            title={group.GroupName}
        >
            <span className="product-group-item-text">
                {group.GroupName}
            </span>
        </button>
    );
};

export default ProductGroupItem;
